/**
*
* Press
*
*/

import React, { PureComponent } from 'react';
import { AppWrappperHOC } from '../Root/HOC';
import PressImage from '../../assets/images/press.jpg';
import { NEWS_ARTICLES } from './constants';

import BannerText from '../../components/BannerText';
import Container from '../../components/Container';
import WhiteBackground from '../../components/WhiteBackground';
import News from './news';

class Press extends PureComponent { // eslint-disable-line react/prefer-stateless-function
  render() {
    const data = NEWS_ARTICLES;
    return (
      <div>
        <BannerText
          title="Press Room"
          BackgroundImg={PressImage}
        />
        <Container>
          <WhiteBackground>
            {data.map((item) => (
              <News
                key={item.key}
                {...item}
              />
            ))}
          </WhiteBackground>
        </Container>
      </div>
    );
  }
}

const component = (AppWrappperHOC(Press));
export default {
  component,
};



// WEBPACK FOOTER //
// client/containers/Press/index.js